export default __webpack_public_path__ + "7ca89ceb29d440ea751947e35ecf6830.webp";